export default __webpack_public_path__ + "static/media/new.cd492f63.svg";